module.exports = __webpack_public_path__ + "media/hyper/images/attached-files/img-3-f2b8538cdd0e8e0efffcb5331aa11151.jpg";